"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { cn } from "@repo/design-system/utils/cn";
import { memo } from "react";
import { useHeaderImage } from "../../headerimage/use-headerimage-eon";
function HeaderImageJobboardEonUk() {
  const $ = _c(13);
  const {
    largeImageSrc,
    smallImageSrc,
    revealImage
  } = useHeaderImage();
  const t0 = !revealImage;
  let t1;
  if ($[0] !== t0) {
    t1 = cn("h-full object-cover object-top transition-opacity duration-200 md:hidden", {
      "opacity-0": t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== smallImageSrc || $[3] !== t1) {
    t2 = <CustomImage alt="E.ON UK Jobboard Header" className={t1} height={960} key={smallImageSrc} priority={true} sizes="100vw" src={smallImageSrc} width={3000} />;
    $[2] = smallImageSrc;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = !revealImage;
  let t4;
  if ($[5] !== t3) {
    t4 = cn("hidden h-full object-cover object-top transition-opacity duration-200 md:block", {
      "opacity-0": t3
    });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== largeImageSrc || $[8] !== t4) {
    t5 = <CustomImage alt="E.ON UK Jobboard Header" className={t4} height={960} key={largeImageSrc} priority={true} sizes="100vw" src={largeImageSrc} width={3000} />;
    $[7] = largeImageSrc;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="min-h-full md:aspect-3000/960">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export default memo(HeaderImageJobboardEonUk);